// One component per section of the map (nucleus/map.js). Each reads its page
// from usePlace() and renders it in the one page grammar (NucleusPage +
// Inspector + ActionBar).
import SelfSection from '../self/SelfSection';
import GraphSection from '../graph-section/GraphSection';
import RealmsSection from '../realms/RealmsSection';
import AppsSection from '../apps/AppsSection';
import PluginsSection from '../plugins/PluginsSection';
import PeopleSection from '../people/PeopleSection';
import GroupsSection from '../groups/GroupsSection';
import ActivitySection from '../activity/ActivitySection';

export const SECTION_PAGES = {
    self: SelfSection,
    graph: GraphSection,
    realms: RealmsSection,
    apps: AppsSection,
    plugins: PluginsSection,
    people: PeopleSection,
    groups: GroupsSection,
    activity: ActivitySection,
};
